var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { parse, stringify } from "qs";
import SubscriptionUpdateSourceEnum from "../@types/enums/SubscriptionUpdateSourceEnum";
import config from "../config";
var UrlUtil = (function () {
    function UrlUtil() {
    }
    UrlUtil.parseQuery = function (query) {
        try {
            return parse(window.decodeURIComponent(query), { ignoreQueryPrefix: true });
        }
        catch (error) {
            console.error("Failed to parse URL query string '%s'.", query, error);
            return null;
        }
    };
    UrlUtil.parseCancellationParams = function (query) {
        var parsed = this.parseQuery(query);
        if (!parsed || !parsed[this.PARAM_SUBSCRIPTION_ID]) {
            return null;
        }
        var source = parsed[this.PARAM_SOURCE] || null;
        if (source !== null && !Object.values(SubscriptionUpdateSourceEnum).includes(source)) {
            console.info("Ignoring source '%s' because it is invalid.", source);
            source = null;
        }
        return {
            subscription_id: Number(parsed[this.PARAM_SUBSCRIPTION_ID]),
            source: source,
        };
    };
    UrlUtil.getSubscribeAndSaveUrl = function () {
        return this.makeUrl("/cart/subscriptions/");
    };
    UrlUtil.getPaymentMethodsUrl = function () {
        return this.makeUrl("/cart/payment-methods/");
    };
    UrlUtil.getCancelSubscriptionUrl = function (subscriptionId, source) {
        var _a;
        var baseUrl = this.makeUrl("/cancel-subscription/");
        var query = stringify((_a = {},
            _a[this.PARAM_SUBSCRIPTION_ID] = subscriptionId,
            _a[this.PARAM_SOURCE] = source,
            _a));
        return "".concat(baseUrl, "?").concat(query);
    };
    UrlUtil.getOrderUrl = function (orderId) {
        return "".concat(config.ALLIT_URL, "/cart/account_history_info.php?order_id=").concat(orderId);
    };
    UrlUtil.getFavoritesUrl = function () {
        return this.makeUrl("/cart/favorites/");
    };
    UrlUtil.getRecommendationsUrl = function () {
        return this.makeUrl("/cart/recommendations/");
    };
    UrlUtil.getProductUrl = function (product) {
        var _a;
        if (!product.slug) {
            return undefined;
        }
        var url = new URL(product.slug, config.ALLIT_URL);
        var parsed = this.parseQuery(url.search);
        if (!parsed) {
            return undefined;
        }
        var query = stringify(__assign(__assign({}, parsed), (_a = {}, _a[product.is_apparel ? this.PARAM_VARIANT_ID : this.PARAM_PRODUCT_ID] = product.product_id, _a)));
        return this.makeUrl("".concat(url.pathname.replace(/\/+$/u, ""), "/?").concat(query).concat(url.hash));
    };
    UrlUtil.makeUrl = function (allitUri) {
        var _a;
        var url = "".concat(config.ALLIT_URL).concat(allitUri);
        return config.NODE_ENV === "production"
            ? url
            : (_a = this.ALLIT_URI_TO_WEBPACK_DEV_URI.get(allitUri)) !== null && _a !== void 0 ? _a : url;
    };
    UrlUtil.ALLIT_URI_TO_WEBPACK_DEV_URI = new Map([
        ["/cart/recommendations/", "/cart/recommendations"],
        ["/cart/favorites/", "/cart/favorites"],
        ["/cart/subscriptions/", "/cart/subscriptions"],
        ["/cart/payment-methods/", "/cart/payment-methods"],
        ["/cancel-subscription/", "/cancel-subscription.html"],
    ]);
    UrlUtil.PARAM_SUBSCRIPTION_ID = "subscription_id";
    UrlUtil.PARAM_SOURCE = "source";
    UrlUtil.PARAM_PRODUCT_ID = "pid";
    UrlUtil.PARAM_VARIANT_ID = "variant";
    return UrlUtil;
}());
export default UrlUtil;
//# sourceMappingURL=UrlUtil.js.map